/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-param-reassign */
/* eslint-disable symbol-description */
import axios from 'axios'
import { BASE_API_URL } from 'Constants'
import i18next from 'I18n'
import JSONBig from 'json-bigint'
import { assign, isEmpty } from 'lodash'
import { history } from 'Stores/reducers'
import { getLocalStorage, STORAGE } from 'Utils'
import { getCookie } from 'Utils/cookies'

const singletonEnforcer = Symbol()
const BASE_URL = `${BASE_API_URL}/`
class AxiosClient {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) {
      throw new Error('Cannot initialize Axios client single instance')
    }

    this.axiosClient = axios.create({
      baseURL: BASE_URL,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })

    // this.getExistTokenOnLocalStorage()

    this.axiosClient.defaults.transformResponse = (data) => JSONBig.parse(data)

    this.axiosClient.interceptors.request.use(
      (configure) => {
        const token = getCookie(STORAGE.USER_TOKEN) || getLocalStorage(STORAGE.USER_TOKEN)
        if (token) {
          configure.headers.Authorization = `Bearer ${token}`
        }
        return configure
      },
      (error) => Promise.reject(error)
    )

    this.axiosClient.interceptors.response.use(
      (response) => {
        const { status, data } = response
        if (data?.error?.code === 'NOT_AUTHENTICATED_ERROR') {
          // clearLocalStorage()
          // removeCookie(STORAGE.USER_EMAIL)
          // removeCookie(STORAGE.USER_TOKEN)
          // removeCookie(STORAGE.ROLE)
          history.push('/logout-hidden')
        }
        if (data?.success) {
          return {
            status,
            data
          }
        }
        throw new Error(i18next.t(`error_message:${data?.error?.code}`))
      },
      (error) => {
        if (error.response) {
          const { data, status } = error.response
		  switch (status) {
            case 400:
              break
            case 500:
              break
            case 401:
              break
            case 404:
              break
            case 403:
              break
            default:
              break
		  }
		  throw data
        } else {
          throw error
        }
      }
    )
  }

  static get instance() {
    if (!this.axiosClientInstance) {
      this.axiosClientInstance = new AxiosClient(singletonEnforcer)
    }

    return this.axiosClientInstance
  }

  async getExistTokenOnLocalStorage() {
    const userToken = await getCookie(STORAGE.USER_TOKEN) || getLocalStorage(STORAGE.USER_TOKEN)
    if (userToken) {
      this.setHeader(userToken)
    }
  }

	setHeader = async (userToken = null) => {
	  this.axiosClient.defaults.headers.common.Authorization = `Bearer ${userToken}`
	};

	get = async (resource, slug = '', config = {}) => {
	  let { headers } = config
	  if (!headers) {
	    headers = this.axiosClient.defaults.headers
	  }
	  slug += ''
	  const requestURL = isEmpty(slug) ? `${resource}` : `${resource}/${slug}`
	  return this.axiosClient.get(requestURL, {
	    data: null,
	    ...assign(config, { headers })
	  })
	};

	post = async (resource, data, config = {}) => this.axiosClient.post(
	    `${resource}`,
	    data,
	    assign(config, this.axiosClient.defaults.headers)
	  );

	update = async (resource, data, config = {}) => this.axiosClient.put(
	    `${resource}`,
	    data,
	    assign(config, this.axiosClient.defaults.headers)
	  );

	put = async (resource, data, config = {}) => this.axiosClient.put(
	    `${resource}`,
	    data,
	    assign(config, this.axiosClient.defaults.headers)
	  );

	patch = async (resource, data, config = {}) => this.axiosClient.patch(
	    `${resource}`,
	    data,
	    assign(config, this.axiosClient.defaults.headers)
	  );

	delete = async (resource, data, config = {}) => this.axiosClient.delete(`${resource}`, {
	    data,
	    ...assign(config, { headers: this.axiosClient.defaults.headers })
	  });
}

export default AxiosClient.instance
